<!-- 最終処分場一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-earth
          </v-icon>
          処分事業場（再資源）
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForm.name"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分事業場名"
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.name = null; searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="searchForm.withoutInvisible"
                        dense
                        label="非表示を表示しない"
                        persistent-hint
                        @change="searchButtonClickEvent()"
                      ></v-checkbox>
                    </v-col>
                  </v-row> -->
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->


    <v-row>
      <v-col class="text-right">
        <v-btn
          :disabled="isJwMode"
          color="primary"
          @click="addButtonClickEvent"
        >
          処分事業場の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat>
          <v-data-table
            :headers="tableHeaders"
            :items="final_disposal_sites"
            :items-per-page="-1"
            disable-sort
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.name`]="{ item }">
              <span :title="item.name">{{ item.name | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.address`]="{ item }">
              <span>{{ item.address | truncate(20) }}</span>
            </template>


            <template v-slot:[`item.location_type`]="{ item }">
              <span>{{ item.location_type === 'only_middle' ? '中間' : '最終(再生含む)' }}</span>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | unix_datetime_format }}
            </template>

            <template v-slot:[`item.registered`]="{ item }">
              <v-icon v-if="!item.registered" color="red">
                mdi-block-helper
              </v-icon>
            </template>

            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="showButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-document-outline
                </v-icon>
                <span v-else>
                  参照
                </span>
              </v-btn>
              <v-btn
                :disabled="isJwMode"
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>
                  編集
                </span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
export default {
  name: 'DriverMasterFinalDisposalSiteIndex',
  components: {
    CustomPagination,
    Confirm
  },
  filters: {
  },
  mixins: [
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      tableHeaders: [
        { text: 'コード', value: 'code' },
        { text: '処分業者名', value: 'trader_name' },
        { text: '許可番号', value: 'recycle_permission_number' },
        { text: '事業場区分', value: 'location_type' },
        { text: '処分事業場名', value: 'name' },
        { text: '郵便番号', value: 'zip_code' },
        { text: '所在地', value: 'address' },
        { text: "再資源化利用", value: "registered", align: "center" },
        { value: 'sort_priority', text: '表示順', align: 'right' },
        { text: '詳細・編集', value: 'editable', align: 'end' },
      ],
      final_disposal_sites: [],
      searchForm: {
        name: null,
      },
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
    }),
    ...mapState('DriverMasterFinalDisposalSite', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('DriverMasterFinalDisposalSite', [
      'hasResult'
    ]),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForm.name = this.searchCondition.name
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchFinalDisposalSites()
  },
  methods: {
    ...mapActions('DriverMasterFinalDisposalSite', {
      fetchFinalDisposalSites: 'index',
      deleteFinalDisposalSites: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    searchButtonClickEvent () {
      this.page = 1
      this.searchFinalDisposalSites()
    },
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$router.push({name: 'DriverMasterFinalDisposalSiteNew'})
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterFinalDisposalSiteEdit', params: { id: item.id }})
    },
    /**
     * 参照ボタン クリックイベント
     * @param item { Object }
     */
     showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterFinalDisposalSite', params: { id: item.id }})
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteFinalDisposalSites({ id: item.id }).then(() =>{
            this.searchFinalDisposalSites()
          })
        }
      })
    },
    changePage(page) {
      this.page = page;
      this.searchFinalDisposalSites()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchFinalDisposalSites()
    },
    searchFinalDisposalSites () {
      let params = {
        name: this.searchForm.name,
        page: this.page,
        limit: this.perPage
      }
      this.fetchFinalDisposalSites(params).then((content) => {
        this.final_disposal_sites = content.final_disposal_sites
      })
    },
  }
}
</script>

<style scoped>

</style>
